import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://api.raveindiapress.com/',
  });


  export default instance;